// extracted by mini-css-extract-plugin
export default {"cardIcon":"CardLink_cardIcon__ApBGp","networkIcon":"CardLink_networkIcon__np26o","cardLinkContainer":"CardLink_cardLinkContainer__axzWg"};